module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "navbar customNavbar"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.root()
      }
    }
  }, [_c('img', {
    staticClass: "logoClass",
    attrs: {
      "src": "/static/logo.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-end"
  }, [_c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.root()
      }
    }
  }, [_vm._v("Inicio")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.about()
      }
    }
  }, [_vm._v("Nosotros")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.products()
      }
    }
  }, [_vm._v("Productos")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.news()
      }
    }
  }, [_vm._v("Noticias")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.contact()
      }
    }
  }, [_vm._v("Contacto")]), _vm._v(" "), (_vm.isLogged) ? _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("Cerrar Sesión")]) : _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_vm._v("Iniciar Sesión")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('carousel', {
    attrs: {
      "autoplay": true,
      "perPage": 1,
      "navigationEnabled": true,
      "loop": true,
      "autoplayTimeout": 1500
    }
  }, _vm._l((_vm.highlights), function(highlight) {
    return _c('slide', {
      key: highlight.id
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.productDetail(highlight.link)
        }
      }
    }, [_c('img', {
      staticClass: "sliderImg",
      attrs: {
        "src": _vm.multimediaBase + highlight.imagePath,
        "alt": highlight.name,
        "width": "500px",
        "height": "200px"
      }
    })])])
  }))], 1)])]), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('br'), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "title is-3"
  }, [_vm._v("Buscador")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('form', [_c('div', {
    staticClass: "field has-addons"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_landing),
      expression: "search_landing"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('search_landing')
    },
    attrs: {
      "data-vv-as": "search",
      "type": "text",
      "name": "search_landing"
    },
    domProps: {
      "value": (_vm.search_landing)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_landing = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('search_landing')),
      expression: "errors.has('search_landing')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('search_landing')))])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button customButton",
    on: {
      "click": function($event) {
        _vm.search()
      }
    }
  }, [_vm._v("Buscar")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr', {
    staticClass: "newsDivider"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "title is-3"
  }, [_vm._v("Noticias")]), _vm._v(" "), _c('div', {
    staticClass: "tile is-ancestor"
  }, _vm._l((_vm.latestNews), function(newsItem) {
    return _c('div', {
      key: newsItem.id,
      staticClass: "tile is-parent"
    }, [_c('article', {
      staticClass: "tile is-child box"
    }, [_c('p', {
      staticClass: "title is-4"
    }, [_vm._v(_vm._s(newsItem.title))]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [(newsItem.firstImage != null) ? _c('img', {
      staticStyle: {
        "margin-right": "20px"
      },
      attrs: {
        "src": _vm.multimediaBase + newsItem.firstImage,
        "width": "150px",
        "align": "left"
      }
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "newsInfo"
    }, [_c('i', [_vm._v(_vm._s(newsItem.dateStr))]), _vm._v(" - " + _vm._s(newsItem.message))])])])])
  }))])]), _vm._v(" "), _c('FooterComponent')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "landingImage",
    attrs: {
      "src": "/static/landing-collage.jpg"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58aeab05","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LandingComponent.vue
// module id = 85
// module chunks = 0